import styled from '@emotion/styled';
import React from 'react';

import { Answer } from 'src/modules/assessments/components/Answer';
import { mediaQueries } from 'src/shared/styles/variables';

const RangeQuestionHolder = styled('div')({
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: 1010,
});

const Answers = styled('ul')({
    listStyleType: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: 0,
    [mediaQueries.md]: {
        flexDirection: 'column',
    },
});

interface AnswerProps {
    needsMarginRight?: boolean;
}

const MultiSelectAnswer = styled(Answer)<AnswerProps>(({ needsMarginRight }) => ({
    marginRight: needsMarginRight ? 10 : 0,
    marginBottom: 10,
}));

interface Option {
    answerText: string;
    value: string | number;
}

interface Props {
    options: Option[];
    currentRate: string[];
    onRateChange: (value: string[]) => void;
}

export enum MultiSelectQuestionTestId {
    Option = 'MultiSelectQuestionTestId.Option',
}

export const MultiSelectQuestion: React.FC<Props> = ({ currentRate, onRateChange, options }) => {
    const handleOnClick = (answer: string) => {
        const next = currentRate.includes(answer)
            ? currentRate.filter(item => item !== answer)
            : [...currentRate, answer];

        onRateChange(next);
    };

    return (
        <>
            <RangeQuestionHolder>
                <Answers>
                    {options?.map(({ answerText, value }, i) => (
                        <MultiSelectAnswer
                            data-testid={MultiSelectQuestionTestId.Option + value}
                            needsMarginRight={i % 2 === 0}
                            key={value}
                            isHighlighted={currentRate?.includes(value.toString())}
                            onClick={() => handleOnClick(value.toString())}
                        >
                            {answerText}
                        </MultiSelectAnswer>
                    ))}
                </Answers>
            </RangeQuestionHolder>
        </>
    );
};
